import QRCode from 'qrcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const LABEL_WIDTH = 1441
const LABEL_HEIGHT = 2161

export default async (opts, indexBoxClosed, statistics, options = {}) => {
    //Information box
    let {id, total_items, total_packages, avatar, warehouse, meta, boxQRData, real_weight, is_fba_box} = opts
    const {hideMadeInVietnam = false} = {...options}
    // Thùng FBA luôn in "MADE IN VIET NAM", rule ẩn chỉ áp dụng cho thùng thường.
    // So sánh `=== true` để thùng thiếu/không có field vẫn được coi là thùng thường.
    const hideMadeInVietnamText = hideMadeInVietnam && is_fba_box !== true
    const {area, has_cap_product} = {...meta}
    const boxNumber = `#${id}`

    //QR image
    const qrDataUrl = await QRCode.toDataURL(boxNumber, {width: 500, margin: 0})
    const qrDataImage = await _makeImage(qrDataUrl)

    //Created canvas
    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT
    const ctx = canvas.getContext('2d')

    //Init canvas page
    ctx.beginPath()
    ctx.fillColor = 'white'
    ctx.fill()

    //Draw rect
    ctx.lineWidth = 4
    ctx.rect(800, 50, 570, 220)
    ctx.stroke()

    ctx.save()

    if(!!real_weight){
        ctx.font = 'bold 200px Arial'
        ctx.fillStyle = 'black'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
    
        const xR = 800 + 570 / 2
        const yR = 65 + 220 / 2
    
        ctx.fillText(real_weight, xR, yR)
        ctx.restore()
    }

    const fillColor = (color = 'black') => ctx.fillStyle = color
    const fillLightColor = (color = 'red') => ctx.fillStyle = color
    const fillFont = (style = '', size = '', font = 'Arial') => {
        ctx.font = [style, size, font].filter(Boolean).join(' ')
    }

    //Draw box close index
    if (indexBoxClosed >= 0) {
        fillColor()
        fillFont('', '200px')
        ctx.fillText(`T${indexBoxClosed + 1}`, 850, 230)
    }

    //Draw QR image
    ctx.drawImage(qrDataImage, 50, 50, 300, 300)

    //Draw box number
    fillColor()
    fillFont('bold', '60px')
    ctx.fillText(boxNumber, 420, 100)

    //Draw total item
    fillColor()
    fillFont('', '60px')
    ctx.fillText(`${total_items} items`, 420, 180)

    //Draw total packages
    fillColor()
    fillFont('', '55px')
    ctx.fillText(`${total_packages} packages`, 420, 260)

    //Draw total packages
    let {name: boxName, extra: boxExtra} = {...boxQRData}
    const boxQRName = [boxName || avatar, warehouse].filter(Boolean).join(' - ')

    fillColor()
    fillFont('', '90px')
    ctx.fillText(boxQRName, 420, 410)
    const boxQRNameWidth = ctx.measureText(boxQRName).width

    if (!boxExtra && ['HW USPS'].includes(avatar) && !!area) {
        boxExtra = area
    }

    // if (!boxExtra && isMTLight) {
    //     boxExtra = 'NHE'
    // }

    // if (boxExtra) {
    //     fillLightColor()
    //     fillFont('bold', '100px')
    //     ctx.fillText(boxExtra, 420 + boxQRNameWidth + 30, 412)
    // }

    if (!!has_cap_product) {
        const boxExtraWidth = ctx.measureText(boxExtra).width
        fillLightColor()
        fillFont('bold', '100px')
        ctx.fillText('Mũ', 420 + boxQRNameWidth + boxExtraWidth + 30, 412)
    }

    //Draw line
    ctx.lineWidth = 6
    ctx.moveTo(50, 460)
    ctx.lineTo(LABEL_WIDTH - 60, 460)
    ctx.stroke()

    //Draw type of box
    // for (let i = 0; i < statistics.length; i++) {
    //     if (i < Math.round(statistics.length / 2)) {
    //         ctx.fillText(statistics[i].type, 50, 540 + i * 80)
    //     } else {
    //         ctx.fillText(statistics[i].type, 720, 540 + (i - Math.round(statistics.length / 2)) * 80)
    //     }
    // }

    //Thùng thường (không phải FBA) chỉ chứa duy nhất 1 đơn hàng thì không in "MADE IN VIET NAM"
    if (!hideMadeInVietnamText) {
        fillColor()
        fillFont('bold', '340px')

        // Dòng 1: "MADE IN"
        ctx.save();
        ctx.translate(820, 580);
        ctx.rotate(Math.PI / 2);
        ctx.fillText('MADE IN', 0, 0);
        ctx.restore();

        // Dòng 2: "VIET NAM"
        ctx.save();
        ctx.translate(380, 540);
        ctx.rotate(Math.PI / 2);
        ctx.fillText('VIET NAM', 0, 0);
        ctx.restore();
    }

    return canvas.toDataURL()
}
